module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    class: _vm.prefixBreadcrumbClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80735a6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/breadcrumb/breadcrumb.vue
// module id = 392
// module chunks = 0